export default __webpack_public_path__ + "static/media/logo_green.8794fe38.svg";